var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDice2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Dice-2--Streamline-Core.svg",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Dice 2 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dice-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 569",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.5 0.5h9s2 0 2 2v9s0 2 -2 2h-9s-2 0 -2 -2v-9s0 -2 2 -2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1036",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 4.5a0.5 0.5 0 1 0 1 0 0.5 0.5 0 1 0 -1 0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1037",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4 9.5a0.5 0.5 0 1 0 1 0 0.5 0.5 0 1 0 -1 0",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDice2);
export default __webpack_public_path__ + "static/media/Dice-2.e4160eec93fbd7b8e2eec9fe17107fb9.svg";
export { ForwardRef as ReactComponent };